const cleanSpaces = (value) => value.trim();

export default cleanSpaces;
